import axios, { AxiosRequestConfig } from 'axios';

import downloadBlob from './downloadBlob';

const downloadServerFile = async (path: string, fileName: string, config: AxiosRequestConfig = {}, download: boolean = false, noAxios: boolean = false) => {
	
	if (noAxios) return downloadBlob(path, fileName);

	const response = await axios.get<string | Blob>(path, {
		...(process.env.NODE_ENV === "development" || download ? { responseType: "blob" } : {}),
		...config,
	});

	return downloadBlob(response.data, fileName);
}

export default downloadServerFile;